module.exports = __webpack_public_path__ + "img/share.7e79fb61.svg";